export const borderRadiusTokens = {
    small: '2px',
    mediumTwo: '8px',
    large: '40px'
};
